import { Checkbox, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { Fragment, useEffect, useState } from "react";
import {
  useExpanded,
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { Table } from "reactstrap";
import CustomIconButton from "../../../../components/Form/CustomIconButton";
import CustomSelect from "../../../../components/Form/CustomSelect";
import CustomSelectMultiple from "../../../../components/Form/CustomSelectMultiple";
import CustomTextField from "../../../../components/Form/CustomTextField";
import Helpers from "../../../../helpers/helpers";
import { DefaultColumnFilter } from "./filters";

// Define a default UI for filtering

const TableContainer = ({
  columns, data = [], customPageSize,
  className, getLengthPage, checkedAll, setCheckedAll, module,
  sort, setSorted, sort_by, setSortBy, submitNewData, categoryList, submitted, creatable, viewable, editable, submittedAdd
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: 0,
        pageSize: customPageSize,
        // sortBy: [
        //   {
        //     desc: true,
        //   },
        // ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  );

  const [pageNo, setPage] = useState(1);
  const [id, setID] = useState("");
  const [configuration, setConfiguration] = useState({
    configuration_name: '',
    category: [],
    isMultipleSelect: '',
    sortOrder: '',
    withQuantitySelection: false,
  });
  const [specificConfiguration, setSpecificConfiguration] = useState({
    configuration_specific_name: '',
    sortOrder: '',
  });

  // const generateSortingIndicator = column => {
  //   return (
  //     <>
  //       {
  //         column.isSorted ?
  //           (column.isSortedDesc ? <i className="ri-sort-desc p-2"></i> : <i className="ri-sort-asc p-2"></i>) : <i className="ri-arrow-up-down-line p-2"></i>
  //       }
  //     </>
  //   )
  // };

  useEffect(() => {
    if (customPageSize && (pageSize !== customPageSize)) {
      setPageSize(customPageSize)
    }
  }, [customPageSize])

  useEffect(() => {
    if (submitted) {
      resetNewConfiguration();
      resetNewSpecificConfiguration();
    }
  }, [submitted])

  useEffect(() => {
    if (submittedAdd) {
      resetNewConfiguration();
      resetNewSpecificConfiguration();
    }
  }, [submittedAdd])

  const generateSortingIndicator = column => {
    if (sort === "asc") {
      return <i className="ri-arrow-up-s-fill p-2"></i>
    } else if (sort === "desc")
      return <i className="ri-arrow-down-s-fill p-2"></i>
  };

  const handleChangeConfiguration = (field, val) => {
    setConfiguration({ ...configuration, [field]: val });
  }
  const handleChangeSpecificConfiguration = (field, val) => {
    setSpecificConfiguration({ ...specificConfiguration, [field]: val });
  }

  const handleSort = (columnID, idx) => {
    setSortBy && setSortBy(columnID?.columnID)
    setID(idx)
    sort === "asc" ? setSorted("desc") : setSorted("asc")
  }

  const resetNewConfiguration = () => {
    setConfiguration({
      configuration_name: '',
      category: [],
      isMultipleSelect: '',
      sortOrder: '',
      withQuantitySelection: false,
    })
  }
  const resetNewSpecificConfiguration = () => {
    setSpecificConfiguration({
      configuration_specific_name: '',
      sortOrder: '',
    })
  }
  
  const renderInputField = () => {
    return (
      <tr key={'input-field'} style={{ backgroundColor: 'white', position: 'relative' }}>
        {
          module === 'configuration-list' && creatable &&
          <>
          <td></td>
            <td>
              <CustomTextField
                values={configuration?.configuration_name}
                onChange={(e) => handleChangeConfiguration('configuration_name', e)}
                placeholder={'e.g Processor'}
              />
            </td>
            <td>
              <CustomSelect
                valueName={"icon"}
                labelName={"label"}
                icon={true}
                values={configuration?.icon_name || '-1'}
                onChange={(e) => handleChangeConfiguration('icon_name', e)}
                placeholder={'Select one'}
                data={Helpers?.icon || []}
              />
            </td>
            <td>
              <CustomSelectMultiple
                values={configuration?.category || '-1'}
                onChange={(e) => handleChangeConfiguration('category', e)}
                placeholder={'Select one or more'}
                data={categoryList}
              />
            </td>
            <td style={{ paddingTop: 18 }}>
              <Checkbox checked={configuration?.isMultipleSelect} sx={{
                color: '#D0D0D0',
                alignSelf: 'center',
                '&.Mui-checked': {
                  color: "var(--bs-theme-color)",
                },
              }} onChange={(event) => handleChangeConfiguration('isMultipleSelect', event.target.checked)} />
            </td>
            {/* <td style={{ paddingTop: 18 }}>
              <Checkbox checked={configuration?.withQuantitySelection} sx={{
                color: '#D0D0D0',
                alignSelf: 'center',
                '&.Mui-checked': {
                  color: "var(--bs-theme-color)",
                },
              }} onChange={(event) => handleChangeConfiguration('withQuantitySelection', event.target.checked)} />
            </td> */}
            <td>
              <CustomTextField
                values={configuration?.sortOrder}
                type="phone"
                onChange={(e) => handleChangeConfiguration('sortOrder', e)}
                placeholder={'0'}
              />
            </td>
            <td style={{ paddingTop: 25, color: '#505D69', position: 'sticky', right: 0, zIndex: 2, backgroundColor: 'white' }}>
              <CustomIconButton
                iconName={'ri-check-line'}
                onClick={() => { submitNewData(configuration) }}
              />
              <CustomIconButton
                iconName={'ri-close-line'}
                onClick={() => resetNewConfiguration()}
              />
            </td>
          </>
        }
        {
          module === 'view-configuration' && creatable &&
          <>
          <td></td>
            <td>
              <CustomTextField
                values={specificConfiguration?.configuration_specific_name}
                onChange={(e) => handleChangeSpecificConfiguration('configuration_specific_name', e)}
                placeholder={'e.g. Intel® Core™ i9'}
              />
            </td>
            <td>
              <CustomTextField
                values={specificConfiguration?.sortOrder}
                onChange={(e) => handleChangeSpecificConfiguration('sortOrder', e)}
                placeholder={'0'}
                type={"number"}
              />
            </td>
            <td style={{ paddingTop: 25, color: '#505D69', position: 'sticky', right: 0, zIndex: 2, backgroundColor: 'white' }}>
              {creatable && <CustomIconButton
                iconName={'ri-check-line'}
                onClick={() => { submitNewData(specificConfiguration) }}
              />}
              {creatable && <CustomIconButton
                iconName={'ri-close-line'}
                onClick={() => resetNewSpecificConfiguration()}
              />}
            </td>
          </>
        }
      </tr>
    )
  }

  return (
    <Fragment>
      <div className="table-responsive react-table" style={{ backgroundColor: 'white' }}>
        <Table hover {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap">
            {headerGroups.map((headerGroup, idx) => (
              <tr key={idx} style={{ fontFamily: 'Manrope-Bold', position: 'relative' }}>
                {headerGroup.headers.map((column, idx) => (
                  <th
                    key={idx}
                    style={
                      column?.position === 'sticky' ? { minWidth: column?.minWidth || 0, position: 'sticky', right: 0, zIndex: 2, backgroundColor: '#F9F9F9' } :
                        { minWidth: column?.minWidth || 0, backgroundColor: '#F9F9F9' }
                    }
                  >
                    {
                      column.render("Header") === "#" ?
                        <Checkbox checked={Boolean(checkedAll)} sx={{
                          paddingBlock: 0,
                          color: '#D0D0D0',
                          '&.Mui-checked': {
                            color: "var(--bs-theme-color)",
                          },
                        }} onChange={(event) => setCheckedAll(!checkedAll)} />
                        : column.render("Header") === "Claimed?" ?
                          <div className="d-flex align-items-end justify-content-center row m-0">
                            <div style={{ color: '#505D69' }}>
                              {column.render("Header")}
                            </div>
                            <div className="d-flex justify-content-center">
                              <Checkbox checked={Boolean(checkedAll)} sx={{
                                '&.Mui-checked': {
                                  color: "var(--bs-theme-color)",
                                },
                                padding: 0
                              }} onChange={(event) => setCheckedAll(!checkedAll)} />
                            </div>
                          </div>
                          :
                          <div style={{ color: '#505D69', cursor: "pointer", }} onClick={(e) => columns[idx]?.columnID ? handleSort(columns[idx], idx) : ""}>
                            {column.render("Header")}
                            {
                              column?.tooltipMessage &&
                              <Tooltip title={column.tooltipMessage} className="mx-2" placement="top"><i className="ri-information-line" /></Tooltip>
                            }
                            {columns[idx]?.columnID ? id === idx ? generateSortingIndicator(column) : <i className="ri-expand-up-down-fill p-2"></i> : ""}
                          </div>
                    }
                    {/* <Filter column={column} /> */}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          {
            // data?.length > 0 &&
            <tbody {...getTableBodyProps()}>
              {renderInputField()}
              {data?.length > 0 && Array?.isArray(data) && page && page?.length > 0 && page.map((row, idx) => {
                prepareRow(row);
                return (
                  <tr key={idx}
                    style={{ backgroundColor: 'white' }}>
                    {row.cells.map((cell, idx) => (
                      <td key={idx}
                        style={
                          cell.column.Header === 'Action' ?
                            { color: '#505D69', position: 'sticky', right: 0, zIndex: 2, backgroundColor: 'white' }
                            :
                            { color: '#505D69', backgroundColor: 'white' }
                        }>
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          }
        </Table>
        {/* {

          data?.length <= 0 &&
          <>
            <div className="d-flex justify-content-center w-100 pb-2" key={'no record-1'}>
              <img src={no_data_image} alt="empty-data" style={{ height: 120, width: 120 }} />
            </div>
            <div className="d-flex justify-content-center w-100 pb-2" key={'no record-2'} style={{ marginBottom: 10, color: '#999999' }}>
              No data available
            </div>
          </>
        } */}

      </div>

    </Fragment>
  );
};

TableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default TableContainer;